/*
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-05-31 19:32:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import weui from 'weui.js'
import WeVue from 'we-vue'
import 'weui'
import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant).use(WeVue)

Vue.config.productionTip = false
Vue.prototype.$weui = weui
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js